import { defaultDirection } from "../constants/defaultValues";
import { NotificationManager } from "../components/common/react-notifications";
import { END_POINT } from "../constants/defaultValues";
import axios from "axios";

const getBasePublicUrl = () =>
  (process.env.PUBLIC_URL || "").replace(/\/+$/, "");

export const getPublicAssetUrl = (assetPath = "") => {
  const normalizedAssetPath = String(assetPath || "").trim();
  if (!normalizedAssetPath) return "";

  if (
    /^(https?:)?\/\//i.test(normalizedAssetPath) ||
    normalizedAssetPath.startsWith("blob:") ||
    normalizedAssetPath.startsWith("data:")
  ) {
    return normalizedAssetPath;
  }

  const cleanedAssetPath = normalizedAssetPath
    .replace(/\\/g, "/")
    .replace(/^\.?\/*/, "");

  return `${getBasePublicUrl()}/${cleanedAssetPath}`.replace(
    /([^:]\/)\/+/g,
    "$1",
  );
};

export const DEFAULT_AVATAR = getPublicAssetUrl(
  "assets/img/default-avatar-vmass.png",
);
export const DEFAULT_COVER = getPublicAssetUrl("assets/img/balloon.jpg");

export const ToTitleCaseName = (value) => {
  const normalized = `${value || ""}`.trim().replace(/\s+/g, " ");
  if (!normalized) return "";

  return normalized
    .toLocaleLowerCase("vi-VN")
    .replace(
      /(^|[\s'-])(\p{L})/gu,
      (match, separator, letter) =>
        separator + letter.toLocaleUpperCase("vi-VN"),
    );
};

const normalizeImageValue = (image) => {
  if (image === null || image === undefined) return "";

  const normalized = String(image).trim();
  if (!normalized) return "";

  const lowered = normalized.toLowerCase();
  if (/^(null|undefined|nan)([./\\-]|$)/.test(lowered)) return "";

  return normalized;
};

export const hasImageValue = (image) => Boolean(normalizeImageValue(image));

const joinUrl = (baseUrl, path) => {
  const normalizedBaseUrl = String(baseUrl || "").replace(/\/+$/, "");
  const normalizedPath = String(path || "").replace(/^\/+/, "");
  return `${normalizedBaseUrl}/${normalizedPath}`;
};

const buildImageUrl = (image, fallbackImage) => {
  const normalizedImage = normalizeImageValue(image);

  if (normalizedImage) {
    if (
      /^(https?:)?\/\//i.test(normalizedImage) ||
      normalizedImage.startsWith("blob:") ||
      normalizedImage.startsWith("data:")
    ) {
      return normalizedImage;
    }

    const cleanedImage = normalizedImage.replace(/\\/g, "/");

    if (
      cleanedImage.startsWith("/assets/") ||
      cleanedImage.startsWith("assets/")
    ) {
      return getPublicAssetUrl(cleanedImage);
    }

    if (cleanedImage.startsWith("/uploads/")) {
      return `${END_POINT.replace(/\/+$/, "")}${cleanedImage}`;
    }

    if (cleanedImage.startsWith("uploads/")) {
      return joinUrl(END_POINT, cleanedImage);
    }

    if (cleanedImage.startsWith("/public/")) {
      return `${END_POINT.replace(/\/+$/, "")}${cleanedImage}`;
    }

    if (cleanedImage.startsWith("public/")) {
      return joinUrl(END_POINT, cleanedImage);
    }

    if (cleanedImage.startsWith("/")) {
      return `${END_POINT.replace(/\/+$/, "")}${cleanedImage}`;
    }

    return joinUrl(END_POINT, `public/${cleanedImage}`);
  }

  return fallbackImage;
};

export const getImageUrl = (image, fallbackImage = "") =>
  buildImageUrl(image, fallbackImage);

// Chuyển giá trị hiển thị (VD: "50.000" hoặc "50000.00") sang số nguyên string để gửi API
export const CleanPrice = (value) => {
  if (!value && value !== 0) return "0";
  // Nếu đã là số, trả về phần nguyên
  const num = parseFloat(String(value).replace(/,/g, ""));
  if (isNaN(num)) return "0";
  return String(Math.trunc(num));
};

export const AddCommaNumber = (number) => {
  if (!number && number !== 0) return number;

  // Chuyển sang số trước để loại bỏ decimal trailing (VD: "50000.00" → 50000)
  const num = parseFloat(number);
  if (isNaN(num)) return number;

  const negative = num < 0 ? "-" : "";
  // Lấy phần nguyên (bỏ phần thập phân)
  const intPart = Math.abs(Math.trunc(num)).toString();
  return negative + intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
};

// export const AddCommaNumber = (number) => {
//     if (number === null || number === undefined) return number;

//     let numStr = String(number);

//     // Tách phần nguyên và phần thập phân
//     let parts = numStr.split('.');
//     let integerPart = parts[0];
//     let decimalPart = parts.length > 1 ? '.' + parts[1] : '';

//     // Áp dụng regex chỉ cho phần nguyên
//     // Regex này sẽ không ảnh hưởng đến dấu trừ ở đầu
//     const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

//     return formattedIntegerPart + decimalPart;
// };

export const AddCommaPhoneNumber = (number) => {
  if (!number) return number;

  let negative = "";
  if (parseFloat(number) < 0) {
    negative = "-";
  }
  number = number.toString();
  return (
    negative +
    number
      .replace(/\D/g, "")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      .replace(".", "")
  );
};

export const MaskPhoneNumber = (phone) => {
  if (!phone) return "";
  const str = phone.toString();
  if (str.length < 5) return str;
  return str.substring(0, 3) + "*****" + str.substring(str.length - 2);
};
export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    var A = a[key],
      B = b[key];
    if (order.indexOf(A + "") > order.indexOf(B + "")) {
      return 1;
    } else {
      return -1;
    }
  });
  return array;
};

export const getDateWithFormat = (date) => {
  let today = new Date();

  if (date) {
    today = new Date(date);
  }

  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = "0" + dd;
  }
  if (mm < 10) {
    mm = "0" + mm;
  }
  // return dd + '/' + mm + '/' + yyyy;
  return yyyy + "-" + mm + "-" + dd;
};

export const getCurrentDate = (momentDateTime) => {
  var options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: "Asia/Ho_Chi_Minh",
  };

  let curr = new Date().toLocaleDateString("vn-VN", options).split("/");
  if (momentDateTime) {
    curr = new Date(momentDateTime)
      .toLocaleDateString("vn-VN", options)
      .split("/");
  }

  let yyyy = curr[2];
  let mm = curr[0];
  let dd = curr[1];

  if (curr.length <= 1) return curr[0];

  return yyyy + "-" + mm + "-" + dd;
};

export const getCurrentTime = () => {
  const now = new Date();
  return now.getHours() + ":" + now.getMinutes();
};

export const getAvatar = (image) => {
  return buildImageUrl(image, DEFAULT_AVATAR);
};

export const getCoverImage = (image) => {
  return buildImageUrl(image, DEFAULT_COVER);
};

export const getQrPay = (bank_code, account_number) => {
  if (!bank_code || !account_number) {
    return false;
  }
  return `https://img.vietqr.io/image/${bank_code}-${account_number}-qr_only.jpg`;
};

export const getQrPayWithCash = (bank_code, account_number, amount) => {
  if (!bank_code || !account_number || !amount) {
    return false;
  }
  return `https://img.vietqr.io/image/${bank_code}-${account_number}-qr_only.jpg?amount=${amount}`;
};

export const getQrPayWithCashAndInfo = (
  bank_code,
  account_number,
  amount,
  info,
) => {
  if (!bank_code || !account_number || !amount) {
    return false;
  }
  const encodedInfo = encodeURIComponent(info || "");
  return `https://img.vietqr.io/image/${bank_code}-${account_number}-qr_only.jpg?amount=${amount}&addInfo=${encodedInfo}`;
};

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem("direction")) {
    const localValue = localStorage.getItem("direction");
    if (localValue === "rtl" || localValue === "ltr") {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === "rtl",
  };
};

export const collect = (props) => {
  return { data: props.data };
};

export const setDirection = (localValue) => {
  let direction = "ltr";
  if (localValue === "rtl" || localValue === "ltr") {
    direction = localValue;
  }
  localStorage.setItem("direction", direction);
};

export const RandomString = (len = 5) =>
  Math.random()
    .toString(36)
    .replace(/[^a-z]+/g, "")
    .substr(0, len);
export const RandomNumber = (len = 5) =>
  Math.random()
    .toString(10)
    .replace(/[a-z.0]+/g, "1")
    .substr(0, len);

export const NotificatioErrController = (message) => {
  NotificationManager.error(
    message || "Đã có lỗi xảy ra",
    "Lỗi !",
    3000,
    null,
    null,
    "filled",
  );
};

// Show API error with i18n support: checks for messageKey from backend, falls back to responseText
export const showApiError = (err, intl) => {
  const data = err?.response?.data;
  if (!data) {
    NotificatioErrController(
      intl
        ? intl.formatMessage({ id: "home.notify.error" })
        : "Đã có lỗi xảy ra",
    );
    return;
  }
  // Try i18n messageKey first, fallback to responseText
  let message = data.responseText || data.message;
  if (data.messageKey && intl) {
    try {
      const translated = intl.formatMessage({ id: data.messageKey });
      if (translated !== data.messageKey) {
        message = translated;
      }
    } catch (e) {
      // Key not found in locale, use responseText fallback
    }
  }
  NotificatioErrController(message);
};

export const NotificatioSucController = (message) => {
  NotificationManager.primary(message, "", 3000, null, null, "filled");
};

export const NotificatioSucSticky = (message) => {
  // Timeout 0 usually means sticky/persistent in many libraries, or use a very large number
  // react-notifications doesn't strictly document '0' as sticky in all versions,
  // but checking source code or common usage: 30000 (30s) or manual close.
  // Let's try 0 first, if not supported, we assume user means "very long" or manually closeable.
  // Actually NotificationManager.success(message, title, timeOut, callback, priority)
  NotificationManager.success(message, "Thông báo", 600000, null, null); // 10 minutes
};

// Seen
export const getUnSeen = (user) => {
  // let local_id = localStorage.getItem("user_id");
  let local_id = localStorage.getItem("b");

  if (user.user_id) {
    if (user.user_id == local_id) {
      // my sender
      return true;
    } else {
      // my receiver
      return user.isSeen;
    }
  }
  if (user.sender_id) {
    if (user.sender_id == local_id) {
      return true;
    } else {
      return user.isSeen;
    }
  }
  return false;
};

export const getCompanyImage = (company) => {
  const companyImage =
    company && typeof company === "object" ? company.companyImage : company;
  return getCoverImage(companyImage);
};

export const getChatDisplayTime = (user) => {
  if (user.data && user.time) return user.date + " - " + user.time;
  return "";
};

export const CheckConfirmPassword = async (confirmPassword) => {
  if (confirmPassword != null || confirmPassword != "") {
    let confirm = await axios
      .post(`${END_POINT}/auth/signin`, {
        username: getUserName(),
        password: confirmPassword,
        domain: getDomain(),
      })
      .then((res) => res.data)
      .catch((err) => err.response);

    if (confirm.status !== 200) {
      return false;
    }
  } else {
    return false;
  }

  return true;
};

// Detect Electron environment
const isElectron = !!window.electronAPI;

// Get store/domain from subdomain or localStorage for Electron
export const getStore = () => {
  const localDomain =
    typeof localStorage !== "undefined"
      ? localStorage.getItem("vmass_store_domain") ||
        localStorage.getItem("domain")
      : "";
  if (localDomain) {
    return localDomain;
  }
  try {
    const userStr =
      typeof localStorage !== "undefined" ? localStorage.getItem("user") : null;
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user && user.domain) {
        return user.domain;
      }
    }
  } catch (e) {}

  if (isElectron || typeof window === "undefined") {
    return "";
  }
  const hostPart = window.location.host.split(".")[0];
  if (
    hostPart &&
    hostPart !== "localhost" &&
    !hostPart.startsWith("localhost:") &&
    hostPart !== "127" &&
    hostPart !== "app" &&
    hostPart !== "web" &&
    hostPart !== "admin"
  ) {
    return hostPart;
  }
  return "";
};

const getDomain = () => {
  return getStore();
};

const getUserName = () => {
  return localStorage.getItem("username");
};

export const IsRedirectFromAlert = (props) => {
  if (props.location && props.location.aboutProps) {
    const { message_item_id, message_user_id } = props.location.aboutProps;
    if (message_user_id && message_item_id) return true;

    return false;
  }
};

export const SetItemsSelected = (id, items, permission) => {
  let selected = items;
  let selectedSet = items;

  if (selected.includes(id)) {
    if (permission !== "require") {
      // dont remove if id is required
      selectedSet = selected.filter((items) => items !== id);
    }
  } else {
    selected.push(id);

    let set = new Set(selected);
    selectedSet = Array.from(set);
  }

  return selectedSet;
};

export const ScrollDetect = () => {
  var lastScroll = 0;

  window.onscroll = function () {
    let currentScroll = 0;

    if (document) {
      if (document.documentElement) {
        currentScroll = document.documentElement.scrollTop;
      }

      if (document.body) {
        currentScroll = document.body.scrollTop;
      }
    }
    // let currentScroll = document.documentElement.scrollTop || document.body.scrollTop; // Get Current Scroll Value

    if (currentScroll > 0 && lastScroll <= currentScroll) {
      lastScroll = currentScroll;

      const navbar = document.getElementsByClassName("navbar");
      if (navbar) {
        navbar[0].style.transition = "opacity 0.5s linear 0s";
        navbar[0].style.opacity = "0";
        navbar[0].style.height = "0";
      }
    } else {
      lastScroll = currentScroll;
      const navbar = document.getElementsByClassName("navbar");
      if (navbar.length) {
        navbar[0].style.opacity = "1";
        navbar[0].style.height = "inherit";
      }
    }
  };
};

export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("vi-VN");
};

// Helper function để lấy placeholder image theo ngành hàng
export const getPlaceholderImage = (businessType) => {
  const normalizedBusinessType = String(businessType || "")
    .toLowerCase()
    .trim();
  const placeholders = {
    // Cafe: Ly cafe đơn giản
    cafe: `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240"><rect fill="#f5f0e8" width="320" height="240"/><rect x="110" y="90" width="80" height="70" rx="5" fill="#8B4513"/><rect x="190" y="100" width="20" height="40" rx="10" fill="none" stroke="#8B4513" stroke-width="4"/><ellipse cx="150" cy="95" rx="35" ry="8" fill="#D2B48C" opacity="0.6"/><path d="M130 70 Q135 50 140 70 M150 65 Q155 45 160 65 M170 70 Q175 50 180 70" stroke="#999" stroke-width="2" fill="none" opacity="0.5"/><text x="160" y="200" text-anchor="middle" font-family="Arial" font-size="14" fill="#8B4513">Cafe</text></svg>`,
    )}`,

    // Restaurant: Đĩa với dao dĩa
    restaurant: `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240"><rect fill="#faf8f5" width="320" height="240"/><circle cx="160" cy="110" r="55" fill="#fff" stroke="#ddd" stroke-width="3"/><circle cx="160" cy="110" r="40" fill="#f8f8f8"/><rect x="80" y="60" width="4" height="100" rx="2" fill="#888"/><rect x="230" y="60" width="4" height="70" rx="2" fill="#888"/><rect x="226" y="130" width="12" height="30" rx="2" fill="#888"/><text x="160" y="200" text-anchor="middle" font-family="Arial" font-size="14" fill="#666">Nhà hàng</text></svg>`,
    )}`,

    // Fashion: Áo treo
    fashion: `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240"><rect fill="#f8f4f9" width="320" height="240"/><path d="M160 45 L160 60" stroke="#666" stroke-width="3"/><circle cx="160" cy="40" r="6" fill="none" stroke="#666" stroke-width="3"/><path d="M160 60 L110 90 M160 60 L210 90" stroke="#666" stroke-width="3" fill="none"/><path d="M115 90 L100 170 L130 170 L140 110 L180 110 L190 170 L220 170 L205 90 Z" fill="#6B8E9F"/><text x="160" y="200" text-anchor="middle" font-family="Arial" font-size="14" fill="#6B8E9F">Thời trang</text></svg>`,
    )}`,

    // Retail: Túi shopping
    retail: `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240"><rect fill="#f0f5f0" width="320" height="240"/><path d="M110 80 L100 170 L220 170 L210 80 Z" fill="#4CAF50"/><path d="M130 80 L130 60 Q130 40 160 40 Q190 40 190 60 L190 80" stroke="#333" stroke-width="4" fill="none"/><text x="160" y="200" text-anchor="middle" font-family="Arial" font-size="14" fill="#4CAF50">Bán lẻ</text></svg>`,
    )}`,

    // Grocery: Giỏ hàng
    grocery: `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240"><rect fill="#fff8e7" width="320" height="240"/><path d="M90 70 L110 70 L140 150 L200 150 L220 90 L125 90" stroke="#FF9800" stroke-width="4" fill="none"/><circle cx="145" cy="170" r="10" fill="#FF9800"/><circle cx="195" cy="170" r="10" fill="#FF9800"/><text x="160" y="205" text-anchor="middle" font-family="Arial" font-size="14" fill="#FF9800">Tạp hóa</text></svg>`,
    )}`,

    // Cosmetics / Beauty: Túi mỹ phẩm
    cosmetics: `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240"><rect fill="#fff4f7" width="320" height="240"/><rect x="106" y="82" width="108" height="92" rx="14" fill="#f472b6"/><path d="M132 82 L132 68 Q132 48 160 48 Q188 48 188 68 L188 82" stroke="#9d174d" stroke-width="5" fill="none"/><circle cx="138" cy="116" r="10" fill="#ffe4ef"/><rect x="154" y="108" width="38" height="16" rx="8" fill="#ffe4ef"/><text x="160" y="205" text-anchor="middle" font-family="Arial" font-size="14" fill="#be185d">Mỹ phẩm</text></svg>`,
    )}`,

    // Pharmacy: Viên thuốc / Capsule
    pharmacy: `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240"><rect fill="#e6f4ea" width="320" height="240"/><g transform="rotate(45 160 110)"><rect x="140" y="70" width="40" height="80" rx="20" fill="#34a853"/><path d="M140 110 L180 110 L180 130 A20 20 0 0 1 140 130 Z" fill="#fff" opacity="0.85"/></g><line x1="130" y1="120" x2="190" y2="100" stroke="#2e7d32" stroke-width="3" opacity="0.3"/><text x="160" y="200" text-anchor="middle" font-family="Arial" font-size="14" font-weight="bold" fill="#2e7d32">Nhà thuốc</text></svg>`,
    )}`,

    // Electronics: Màn hình / Laptop
    electronics: `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240"><rect fill="#eaeff2" width="320" height="240"/><rect x="100" y="60" width="120" height="80" rx="8" fill="#4a5568"/><rect x="106" y="66" width="108" height="64" rx="4" fill="#1a202c"/><rect x="145" y="140" width="30" height="20" fill="#4a5568"/><rect x="120" y="160" width="80" height="6" rx="3" fill="#4a5568"/><text x="160" y="205" text-anchor="middle" font-family="Arial" font-size="14" font-weight="bold" fill="#4a5568">Điện máy</text></svg>`,
    )}`,

    // Spa / Salon: Bông sen nghệ thuật
    spa: `data:image/svg+xml,${encodeURIComponent(
      `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240"><rect fill="#fdf2f8" width="320" height="240"/><path d="M160 55 C130 90, 130 130, 160 160 C190 130, 190 90, 160 55 Z" fill="#ec4899" opacity="0.6"/><path d="M160 75 C115 100, 115 130, 160 160 C205 130, 205 100, 160 75 Z" fill="#ec4899" opacity="0.4"/><path d="M160 75 C205 100, 205 130, 160 160 C115 130, 115 100, 160 75 Z" fill="#ec4899" opacity="0.4"/><circle cx="160" cy="120" r="10" fill="#fbcfe8"/><text x="160" y="205" text-anchor="middle" font-family="Arial" font-size="14" font-weight="bold" fill="#db2777">Spa & Salon</text></svg>`,
    )}`,
  };
  placeholders.beauty = placeholders.cosmetics;
  placeholders.salon = placeholders.spa;

  // Default placeholder
  const defaultPlaceholder = `data:image/svg+xml,${encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" width="320" height="240" viewBox="0 0 320 240"><rect fill="#f0f0f0" width="320" height="240"/><rect x="130" y="80" width="60" height="50" rx="5" fill="#ccc"/><circle cx="145" cy="100" r="8" fill="#999"/><path d="M130 130 L160 110 L190 130 Z" fill="#bbb"/><text x="160" y="160" text-anchor="middle" font-family="Arial" font-size="12" fill="#999">Chưa có ảnh</text></svg>`,
  )}`;

  return placeholders[normalizedBusinessType] || defaultPlaceholder;
};

// Helper function để lấy icon class theo ngành hàng (sử dụng iconsminds)
export const getPlaceholderIcon = (businessType, fnbType) => {
  const normalizedBusinessType = String(businessType || "")
    .toLowerCase()
    .trim();
  const normalizedFnbType = String(fnbType || "")
    .toLowerCase()
    .trim();
  if (normalizedFnbType === "food") return "iconsminds-plates";
  if (normalizedFnbType === "drink") return "iconsminds-coffee-balanced";

  const icons = {
    cafe: "iconsminds-coffee-balanced",
    restaurant: "iconsminds-plates",
    fashion: "iconsminds-hanger",
    retail: "iconsminds-shopping-cart",
    cosmetics: "iconsminds-shopping-bag",
    grocery: "iconsminds-shopping-cart",
    pharmacy: "iconsminds-temperature",
    electronics: "iconsminds-computer",
    spa: "iconsminds-flowerpot",
    salon: "iconsminds-scissor",
  };

  return icons[normalizedBusinessType] || "iconsminds-photo";
};

export const DEFAULT_PRINT_PAPER_WIDTH_MM = 80;
export const PRINT_PAPER_PROFILES = {
  80: { paperWidthMm: 80, contentWidthMm: 72 },
  58: { paperWidthMm: 58, contentWidthMm: 48 },
};
export const PRINT_THERMAL_PAPER_WIDTH_MM =
  PRINT_PAPER_PROFILES[DEFAULT_PRINT_PAPER_WIDTH_MM].paperWidthMm;
export const PRINT_THERMAL_CONTENT_WIDTH_MM =
  PRINT_PAPER_PROFILES[DEFAULT_PRINT_PAPER_WIDTH_MM].contentWidthMm;
export const PRINT_WEB_HORIZONTAL_OFFSET_MM = 1.5;
export const PRINT_CUSTOMER_PAPER_WIDTH_STORAGE_KEY = "customerPaperWidthMm";
export const PRINT_KITCHEN_PAPER_WIDTH_STORAGE_KEY = "kitchenPaperWidthMm";

export const PRINT_PAGE_STYLE = `
  @page {
    size: 80mm 297mm;
    margin: 0 !important;
  }
  @media print {
    body {
      margin: 0 !important;
      padding: 0 !important;
      background: #fff !important;
      color: #000 !important;
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
    }
    * {
      color: #000 !important;
      overflow: visible !important;
    }
    #bill-to-print {
      position: absolute;
      width: calc(100% - ${PRINT_WEB_HORIZONTAL_OFFSET_MM}mm) !important;
      max-width: calc(100% - ${PRINT_WEB_HORIZONTAL_OFFSET_MM}mm) !important;
      margin: 0 !important;
      padding: 0 !important;
      left: ${PRINT_WEB_HORIZONTAL_OFFSET_MM}mm !important;
      top: 0 !important;
    }
    #bill-to-print .colxx-12,
    #bill-to-print .col-12,
    #bill-to-print [class*="col-"],
    #bill-to-print [class*="colxx-"] {
      padding-left: 2px !important;
      padding-right: 2px !important;
      margin: 0 !important;
    }
    #bill-to-print .colxx-4,
    #bill-to-print .col-4 {
      width: 75px !important;
      max-width: 75px !important;
      flex: 0 0 75px !important;
      padding: 0 !important;
    }
    #bill-to-print .colxx-8,
    #bill-to-print .col-8 {
      width: calc(100% - 80px) !important;
      max-width: calc(100% - 80px) !important;
      flex: 0 0 calc(100% - 80px) !important;
      padding-left: 6px !important;
      padding-right: 0 !important;
    }
    .invoice-contents {
      color: #000 !important;
      background-color: #fff !important;
      font-size: 12px !important;
      font-weight: normal !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 2px !important;
      box-shadow: none !important;
      border: none !important;
    }
    .invoice-contents p {
      font-size: 12px !important;
      font-weight: normal !important;
      margin-bottom: 3px !important;
    }
    .invoice-contents td,
    .invoice-contents th {
      padding: 3px 2px !important;
    }
    .text-to-print,
    .text-muted,
    .text-semi-muted {
      font-size: 12px !important;
      font-weight: normal !important;
      color: #000 !important;
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
    }
    .text-small,
    .text-small * {
      font-size: 10px !important;
    }
    .text-extra-small,
    .text-extra-small * {
      font-size: 9px !important;
    }
    .invoice-footer-note {
      font-size: 8px !important;
      line-height: 1.2 !important;
      font-weight: normal !important;
      margin-bottom: 2px !important;
    }
    .print-variant-badges {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 2px !important;
      margin-top: 2px !important;
      line-height: 1.2 !important;
    }
    .print-variant-badge {
      display: inline-block !important;
      border: 1px dashed #555 !important;
      border-radius: 3px !important;
      padding: 1px 3px !important;
      margin: 0 2px 2px 0 !important;
      background: #fff !important;
      color: #000 !important;
      font-size: 9px !important;
      font-weight: 500 !important;
      white-space: normal !important;
      max-width: 100% !important;
    }
    .font-weight-bold,
    .font-weight-bold *,
    strong,
    strong *,
    th,
    .text-bold,
    .text-bold * {
      font-weight: bold !important;
    }
    .bg-area-print {
      padding: 3px 6px !important;
    }
    .bg-area-print.align-items-start {
      text-align: left !important;
    }
    .bg-area-print span {
      line-height: 1.1 !important;
      margin-bottom: 2px !important;
    }
    .company-avatar {
      width: 50px !important;
      height: 50px !important;
      margin: 0 auto !important;
    }
    .company-avatar img {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
    }
    .company-name-invoice {
      font-size: 14px !important;
      font-weight: bold !important;
      margin-bottom: 2px !important;
    }
    .company-name-invoice + p,
    .company-name-invoice + p + p {
      font-size: 9px !important;
      line-height: 1.2 !important;
    }
    #bill-to-print .colxx-8 p,
    #bill-to-print .col-8 p {
      font-size: 10px !important;
      line-height: 1.3 !important;
    }
    .card-img-print {
      width: 70px !important;
      height: 70px !important;
      max-width: 70px !important;
      margin: 0 auto !important;
      padding: 2px !important;
    }
    .no-print {
      display: none !important;
    }
    .card {
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
    }
  }
`;

export const SILENT_PRINT_PAGE_STYLE = `
  @page {
    margin: 0 !important;
  }

  html[data-vmass-silent-print="receipt"],
  html[data-vmass-silent-print="receipt"] body {
    min-width: 0 !important;
    margin: 0 !important;
    background: #fff !important;
    color: #000 !important;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }

  html[data-vmass-silent-print="receipt"] {
    width: ${PRINT_THERMAL_PAPER_WIDTH_MM}mm !important;
    max-width: ${PRINT_THERMAL_PAPER_WIDTH_MM}mm !important;
  }

  html[data-vmass-silent-print="receipt"] body {
    width: ${PRINT_THERMAL_CONTENT_WIDTH_MM}mm !important;
    max-width: ${PRINT_THERMAL_CONTENT_WIDTH_MM}mm !important;
    padding: 1mm !important;
    box-sizing: border-box !important;
  }

  html[data-vmass-silent-print="receipt"] *,
  html[data-vmass-silent-print="receipt"] *::before,
  html[data-vmass-silent-print="receipt"] *::after {
    box-sizing: border-box !important;
    max-width: 100% !important;
    overflow: visible !important;
    overflow-wrap: anywhere !important;
    word-break: break-word !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print,
  html[data-vmass-silent-print="receipt"] .invoice-react,
  html[data-vmass-silent-print="receipt"] .invoice-contents {
    position: static !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    left: auto !important;
    top: auto !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print.row,
  html[data-vmass-silent-print="receipt"] #bill-to-print .row,
  html[data-vmass-silent-print="receipt"] .invoice-react.row {
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100% !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print > [class*="col-"],
  html[data-vmass-silent-print="receipt"] #bill-to-print > [class*="colxx-"] {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin: 0 !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print [class*="col-"],
  html[data-vmass-silent-print="receipt"] #bill-to-print [class*="colxx-"] {
    min-width: 0 !important;
    padding-left: 0.5mm !important;
    padding-right: 0.5mm !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print .colxx-4,
  html[data-vmass-silent-print="receipt"] #bill-to-print .col-4 {
    width: 22mm !important;
    max-width: 22mm !important;
    flex: 0 0 22mm !important;
    padding-left: 0 !important;
    padding-right: 1mm !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print .colxx-8,
  html[data-vmass-silent-print="receipt"] #bill-to-print .col-8 {
    width: calc(100% - 22mm) !important;
    max-width: calc(100% - 22mm) !important;
    flex: 1 1 0 !important;
    min-width: 0 !important;
    padding-left: 1mm !important;
    padding-right: 0 !important;
  }

  html[data-vmass-silent-print="receipt"] .invoice-contents {
    color: #000 !important;
    background-color: #fff !important;
    font-size: 12px !important;
    font-weight: normal !important;
    padding: 1mm !important;
    box-shadow: none !important;
    border: none !important;
  }

  html[data-vmass-silent-print="receipt"] .card,
  html[data-vmass-silent-print="receipt"] .card-body {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  html[data-vmass-silent-print="receipt"] .card-body {
    padding: 1mm !important;
    margin: 0 !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print table {
    width: 100% !important;
    max-width: 100% !important;
    table-layout: fixed !important;
    border-collapse: collapse !important;
    margin-bottom: 1.5mm !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print table.d-flex {
    display: table !important;
    width: 100% !important;
    margin-left: 0 !important;
    table-layout: fixed !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print table.d-flex td:first-child {
    width: 58% !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print table.d-flex td:last-child {
    width: 42% !important;
    text-align: right !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print td,
  html[data-vmass-silent-print="receipt"] #bill-to-print th {
    padding: 0.8mm 0.5mm !important;
    white-space: normal !important;
    vertical-align: top !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print table:first-of-type th:first-child,
  html[data-vmass-silent-print="receipt"] #bill-to-print table:first-of-type td:first-child {
    width: 9mm !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print table:first-of-type th:nth-child(3),
  html[data-vmass-silent-print="receipt"] #bill-to-print table:first-of-type td:nth-child(3) {
    width: 17mm !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print table:first-of-type th:nth-child(4),
  html[data-vmass-silent-print="receipt"] #bill-to-print table:first-of-type td:nth-child(4) {
    width: 20mm !important;
  }

  html[data-vmass-silent-print="receipt"] .invoice-contents p {
    font-size: 12px !important;
    font-weight: normal !important;
    margin-bottom: 0.8mm !important;
  }

  html[data-vmass-silent-print="receipt"] .text-to-print,
  html[data-vmass-silent-print="receipt"] .text-muted,
  html[data-vmass-silent-print="receipt"] .text-semi-muted {
    font-size: 12px !important;
    font-weight: normal !important;
    color: #000 !important;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
  }

  html[data-vmass-silent-print="receipt"] .text-small,
  html[data-vmass-silent-print="receipt"] .text-small * {
    font-size: 10px !important;
  }

  html[data-vmass-silent-print="receipt"] .text-extra-small,
  html[data-vmass-silent-print="receipt"] .text-extra-small * {
    font-size: 9px !important;
  }

  html[data-vmass-silent-print="receipt"] .invoice-footer-note {
    font-size: 8px !important;
    line-height: 1.2 !important;
    font-weight: normal !important;
    margin-bottom: 0.5mm !important;
  }

  html[data-vmass-silent-print="receipt"] .print-variant-badges {
    display: flex !important;
    flex-wrap: wrap !important;
    gap: 0.5mm !important;
    margin-top: 0.5mm !important;
    line-height: 1.2 !important;
  }

  html[data-vmass-silent-print="receipt"] .print-variant-badge {
    display: inline-block !important;
    border: 1px dashed #555 !important;
    border-radius: 3px !important;
    padding: 0.3mm 0.8mm !important;
    margin: 0 0.5mm 0.5mm 0 !important;
    background: #fff !important;
    color: #000 !important;
    font-size: 9px !important;
    font-weight: 500 !important;
    white-space: normal !important;
  }

  html[data-vmass-silent-print="receipt"] .font-weight-bold,
  html[data-vmass-silent-print="receipt"] .font-weight-bold *,
  html[data-vmass-silent-print="receipt"] strong,
  html[data-vmass-silent-print="receipt"] strong *,
  html[data-vmass-silent-print="receipt"] th,
  html[data-vmass-silent-print="receipt"] .text-bold,
  html[data-vmass-silent-print="receipt"] .text-bold * {
    font-weight: bold !important;
  }

  html[data-vmass-silent-print="receipt"] .bg-area-print {
    padding: 1mm !important;
  }

  html[data-vmass-silent-print="receipt"] .bg-area-print.align-items-start {
    text-align: left !important;
  }

  html[data-vmass-silent-print="receipt"] .bg-area-print span {
    line-height: 1.1 !important;
    margin-bottom: 0.5mm !important;
  }

  html[data-vmass-silent-print="receipt"] .company-avatar {
    width: 14mm !important;
    height: 14mm !important;
    margin: 0 auto !important;
    flex: 0 0 14mm !important;
  }

  html[data-vmass-silent-print="receipt"] .company-avatar img {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain !important;
  }

  html[data-vmass-silent-print="receipt"] .company-name-invoice {
    font-size: 14px !important;
    font-weight: bold !important;
    margin-bottom: 0.5mm !important;
  }

  html[data-vmass-silent-print="receipt"] .company-name-invoice + p,
  html[data-vmass-silent-print="receipt"] .company-name-invoice + p + p {
    font-size: 9px !important;
    line-height: 1.2 !important;
  }

  html[data-vmass-silent-print="receipt"] #bill-to-print .colxx-8 p,
  html[data-vmass-silent-print="receipt"] #bill-to-print .col-8 p {
    font-size: 10px !important;
    line-height: 1.3 !important;
  }

  html[data-vmass-silent-print="receipt"] .card-img-print {
    width: 18mm !important;
    height: 18mm !important;
    max-width: 18mm !important;
    margin: 0 auto !important;
    padding: 0.5mm !important;
  }

  html[data-vmass-silent-print="receipt"] .no-print {
    display: none !important;
    visibility: hidden !important;
  }

  @media print {
    html,
    body {
      min-width: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      background: #fff !important;
      color: #000 !important;
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
    }

    html {
      width: ${PRINT_THERMAL_PAPER_WIDTH_MM}mm !important;
      max-width: ${PRINT_THERMAL_PAPER_WIDTH_MM}mm !important;
    }

    body {
      width: ${PRINT_THERMAL_CONTENT_WIDTH_MM}mm !important;
      max-width: ${PRINT_THERMAL_CONTENT_WIDTH_MM}mm !important;
      padding: 1mm !important;
      box-sizing: border-box !important;
    }

    *,
    *::before,
    *::after {
      box-sizing: border-box !important;
      max-width: 100% !important;
      color: #000 !important;
      overflow: visible !important;
      overflow-wrap: anywhere !important;
      word-break: break-word !important;
    }

    #bill-to-print,
    .invoice-react,
    .invoice-contents {
      position: static !important;
      width: 100% !important;
      min-width: 0 !important;
      max-width: 100% !important;
      height: auto !important;
      margin: 0 !important;
      left: auto !important;
      top: auto !important;
    }

    #bill-to-print.row,
    #bill-to-print .row,
    .invoice-react.row {
      margin-left: 0 !important;
      margin-right: 0 !important;
      width: 100% !important;
    }

    #bill-to-print > [class*="col-"],
    #bill-to-print > [class*="colxx-"] {
      padding-left: 0 !important;
      padding-right: 0 !important;
      margin: 0 !important;
    }

    #bill-to-print [class*="col-"],
    #bill-to-print [class*="colxx-"] {
      min-width: 0 !important;
      padding-left: 0.5mm !important;
      padding-right: 0.5mm !important;
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }

    #bill-to-print .colxx-4,
    #bill-to-print .col-4 {
      width: 22mm !important;
      max-width: 22mm !important;
      flex: 0 0 22mm !important;
      padding-left: 0 !important;
      padding-right: 1mm !important;
    }

    #bill-to-print .colxx-8,
    #bill-to-print .col-8 {
      width: calc(100% - 22mm) !important;
      max-width: calc(100% - 22mm) !important;
      flex: 1 1 0 !important;
      min-width: 0 !important;
      padding-left: 1mm !important;
      padding-right: 0 !important;
    }

    .invoice-contents {
      color: #000 !important;
      background-color: #fff !important;
      font-size: 12px !important;
      font-weight: normal !important;
      padding: 1mm !important;
      box-shadow: none !important;
      border: none !important;
    }

    .card,
    .card-body {
      border: none !important;
      box-shadow: none !important;
      background: transparent !important;
    }

    .card-body {
      padding: 1mm !important;
      margin: 0 !important;
    }

    #bill-to-print table {
      width: 100% !important;
      max-width: 100% !important;
      table-layout: fixed !important;
      border-collapse: collapse !important;
      margin-bottom: 1.5mm !important;
    }

    #bill-to-print table.d-flex {
      display: table !important;
      width: 100% !important;
      margin-left: 0 !important;
      table-layout: fixed !important;
    }

    #bill-to-print table.d-flex td:first-child {
      width: 58% !important;
    }

    #bill-to-print table.d-flex td:last-child {
      width: 42% !important;
      text-align: right !important;
    }

    #bill-to-print td,
    #bill-to-print th {
      padding: 0.8mm 0.5mm !important;
      white-space: normal !important;
      vertical-align: top !important;
    }

    #bill-to-print table:first-of-type th:first-child,
    #bill-to-print table:first-of-type td:first-child {
      width: 9mm !important;
    }

    #bill-to-print table:first-of-type th:nth-child(3),
    #bill-to-print table:first-of-type td:nth-child(3) {
      width: 17mm !important;
    }

    #bill-to-print table:first-of-type th:nth-child(4),
    #bill-to-print table:first-of-type td:nth-child(4) {
      width: 20mm !important;
    }

    .invoice-contents p {
      font-size: 12px !important;
      font-weight: normal !important;
      margin-bottom: 0.8mm !important;
    }

    .text-to-print,
    .text-muted,
    .text-semi-muted {
      font-size: 12px !important;
      font-weight: normal !important;
      color: #000 !important;
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
    }

    .text-small,
    .text-small * {
      font-size: 10px !important;
    }

    .text-extra-small,
    .text-extra-small * {
      font-size: 9px !important;
    }

    .invoice-footer-note {
      font-size: 8px !important;
      line-height: 1.2 !important;
      font-weight: normal !important;
      margin-bottom: 0.5mm !important;
    }

    .print-variant-badges {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 0.5mm !important;
      margin-top: 0.5mm !important;
      line-height: 1.2 !important;
    }

    .print-variant-badge {
      display: inline-block !important;
      border: 1px dashed #555 !important;
      border-radius: 3px !important;
      padding: 0.3mm 0.8mm !important;
      margin: 0 0.5mm 0.5mm 0 !important;
      background: #fff !important;
      color: #000 !important;
      font-size: 9px !important;
      font-weight: 500 !important;
      white-space: normal !important;
    }

    .font-weight-bold,
    .font-weight-bold *,
    strong,
    strong *,
    th,
    .text-bold,
    .text-bold * {
      font-weight: bold !important;
    }

    .bg-area-print {
      padding: 1mm !important;
    }

    .bg-area-print.align-items-start {
      text-align: left !important;
    }

    .bg-area-print span {
      line-height: 1.1 !important;
      margin-bottom: 0.5mm !important;
    }

    .company-avatar {
      width: 14mm !important;
      height: 14mm !important;
      margin: 0 auto !important;
      flex: 0 0 14mm !important;
    }

    .company-avatar img {
      width: 100% !important;
      height: 100% !important;
      object-fit: contain !important;
    }

    .company-name-invoice {
      font-size: 14px !important;
      font-weight: bold !important;
      margin-bottom: 0.5mm !important;
    }

    .company-name-invoice + p,
    .company-name-invoice + p + p {
      font-size: 9px !important;
      line-height: 1.2 !important;
    }

    #bill-to-print .colxx-8 p,
    #bill-to-print .col-8 p {
      font-size: 10px !important;
      line-height: 1.3 !important;
    }

    .card-img-print {
      width: 18mm !important;
      height: 18mm !important;
      max-width: 18mm !important;
      margin: 0 auto !important;
      padding: 0.5mm !important;
    }

    .no-print {
      display: none !important;
      visibility: hidden !important;
    }
  }
`;

export const normalizePrintPaperWidthMm = (
  paperWidthMm = DEFAULT_PRINT_PAPER_WIDTH_MM,
) => {
  const parsed = Number.parseInt(
    String(paperWidthMm || DEFAULT_PRINT_PAPER_WIDTH_MM).trim(),
    10,
  );
  return PRINT_PAPER_PROFILES[parsed] ? parsed : DEFAULT_PRINT_PAPER_WIDTH_MM;
};

export const getPrintPaperProfile = (paperWidthMm) =>
  PRINT_PAPER_PROFILES[normalizePrintPaperWidthMm(paperWidthMm)];

export const getPrintPaperStorageKey = (documentType = "customer") =>
  documentType === "kitchen"
    ? PRINT_KITCHEN_PAPER_WIDTH_STORAGE_KEY
    : PRINT_CUSTOMER_PAPER_WIDTH_STORAGE_KEY;

export const getStoredPrintPaperWidthMm = (documentType = "customer") => {
  if (typeof localStorage === "undefined") {
    return DEFAULT_PRINT_PAPER_WIDTH_MM;
  }

  try {
    return normalizePrintPaperWidthMm(
      localStorage.getItem(getPrintPaperStorageKey(documentType)),
    );
  } catch (error) {
    return DEFAULT_PRINT_PAPER_WIDTH_MM;
  }
};

const applyPrintPaperProfile = (style, profile) =>
  String(style || "")
    .replace(/80mm/g, `${profile.paperWidthMm}mm`)
    .replace(/72mm/g, `${profile.contentWidthMm}mm`);

const scopedPrintSelector = (scope, selector) =>
  scope ? `${scope} ${selector}` : selector;

const buildCompact58Rules = (scope = "") => {
  const s = (selector) => scopedPrintSelector(scope, selector);

  return `
    ${s("body")} {
      width: ${PRINT_PAPER_PROFILES[58].contentWidthMm}mm !important;
      max-width: ${PRINT_PAPER_PROFILES[58].contentWidthMm}mm !important;
      padding: 0.8mm !important;
    }

    ${s(".invoice-contents")} {
      font-size: 10px !important;
      padding: 0.6mm !important;
    }

    ${s(".invoice-contents p")} {
      font-size: 10px !important;
      margin-bottom: 0.5mm !important;
    }

    ${s(".text-to-print")},
    ${s(".text-muted")},
    ${s(".text-semi-muted")} {
      font-size: 10px !important;
      line-height: 1.2 !important;
    }

    ${s(".text-small")},
    ${s(".text-small *")} {
      font-size: 9px !important;
    }

    ${s(".text-extra-small")},
    ${s(".text-extra-small *")},
    ${s(".invoice-footer-note")} {
      font-size: 8px !important;
      line-height: 1.2 !important;
    }

    ${s(".bg-area-print")} {
      padding: 0.6mm !important;
    }

    ${s(".bg-area-print span")} {
      margin-bottom: 0.4mm !important;
    }

    ${s(".company-avatar")} {
      width: 10mm !important;
      height: 10mm !important;
      flex: 0 0 10mm !important;
    }

    ${s(".company-name-invoice")} {
      font-size: 11px !important;
      line-height: 1.15 !important;
    }

    ${s(".company-name-invoice + p")},
    ${s(".company-name-invoice + p + p")},
    ${s("#bill-to-print .colxx-8 p")},
    ${s("#bill-to-print .col-8 p")} {
      font-size: 8px !important;
      line-height: 1.15 !important;
    }

    ${s(".print-variant-badges")} {
      gap: 0.3mm !important;
      margin-top: 0.3mm !important;
    }

    ${s(".print-variant-badge")} {
      font-size: 8px !important;
      padding: 0.2mm 0.5mm !important;
      margin: 0 0.3mm 0.3mm 0 !important;
    }

    ${s(".card-img-print")} {
      width: 14mm !important;
      height: 14mm !important;
      max-width: 14mm !important;
    }

    ${s("#bill-to-print table:first-of-type")} {
      table-layout: auto !important;
      margin-bottom: 1mm !important;
    }

    ${s("#bill-to-print table:first-of-type thead")} {
      display: none !important;
    }

    ${s("#bill-to-print table:first-of-type tbody")},
    ${s("#bill-to-print table:first-of-type tbody tr")},
    ${s("#bill-to-print table:first-of-type tbody td")} {
      width: 100% !important;
      max-width: 100% !important;
    }

    ${s("#bill-to-print table:first-of-type tbody tr")} {
      display: grid !important;
      grid-template-columns: minmax(0, 1fr) auto;
      column-gap: 1.5mm;
      row-gap: 0.2mm;
      padding: 0.8mm 0 !important;
      border-bottom: 1px dashed #999 !important;
      break-inside: avoid !important;
      page-break-inside: avoid !important;
    }

    ${s("#bill-to-print table:first-of-type tbody td")} {
      display: block !important;
      width: auto !important;
      max-width: none !important;
      padding: 0 !important;
      border: 0 !important;
      white-space: normal !important;
    }

    ${s("#bill-to-print table:first-of-type tbody td:nth-child(2)")} {
      grid-column: 1 / -1;
      grid-row: 1;
      font-size: 10px !important;
      font-weight: bold !important;
      line-height: 1.2 !important;
      text-align: left !important;
    }

    ${s("#bill-to-print table:first-of-type tbody td:first-child")} {
      grid-column: 1;
      grid-row: 2;
      color: #000 !important;
      font-size: 9px !important;
      line-height: 1.2 !important;
      text-align: left !important;
    }

    ${s("#bill-to-print table:first-of-type tbody td:nth-child(3)")} {
      grid-column: 1;
      grid-row: 2;
      padding-left: 8mm !important;
      font-size: 9px !important;
      line-height: 1.2 !important;
      text-align: left !important;
    }

    ${s("#bill-to-print table:first-of-type tbody td:nth-child(4)")} {
      grid-column: 2;
      grid-row: 2;
      font-size: 10px !important;
      font-weight: bold !important;
      line-height: 1.2 !important;
      text-align: right !important;
      white-space: nowrap !important;
    }

    ${s("#bill-to-print table.d-flex td")} {
      font-size: 10px !important;
      padding: 0.4mm 0.2mm !important;
    }
  `;
};

const buildCompact58PrintStyle = () => `
  @media print {
    ${buildCompact58Rules()}
  }
`;

const buildCompact58SilentStyle = () => `
  ${buildCompact58Rules(
    'html[data-vmass-silent-print="receipt"][data-vmass-paper-width-mm="58"]',
  )}

  @media print {
    ${buildCompact58Rules()}
  }
`;

export const buildPrintPageStyle = (
  paperWidthMm = DEFAULT_PRINT_PAPER_WIDTH_MM,
) => {
  const profile = getPrintPaperProfile(paperWidthMm);
  const style = applyPrintPaperProfile(PRINT_PAGE_STYLE, profile);
  return profile.paperWidthMm === 58
    ? `${style}\n${buildCompact58PrintStyle()}`
    : style;
};

export const buildSilentPrintPageStyle = (
  paperWidthMm = DEFAULT_PRINT_PAPER_WIDTH_MM,
) => {
  const profile = getPrintPaperProfile(paperWidthMm);
  const style = applyPrintPaperProfile(SILENT_PRINT_PAGE_STYLE, profile);
  return profile.paperWidthMm === 58
    ? `${style}\n${buildCompact58SilentStyle()}`
    : style;
};

const normalizePrintDocumentType = (documentType = "receipt") => {
  const normalized = String(documentType || "receipt")
    .trim()
    .replace(/[^a-z0-9_-]/gi, "");
  return normalized || "receipt";
};

export const makePrintResourcesAbsolute = (
  contentHtml,
  baseUrl = typeof window !== "undefined" ? window.location.href : "",
) => {
  if (!contentHtml) return "";
  if (typeof document === "undefined") return contentHtml;

  const container = document.createElement("div");
  container.innerHTML = contentHtml;
  container.querySelectorAll("[src], [href]").forEach((element) => {
    ["src", "href"].forEach((attribute) => {
      const value = element.getAttribute(attribute);
      if (!value || value.startsWith("#")) return;
      try {
        const normalizedValue =
          String(baseUrl).startsWith("file:") && value.startsWith("/")
            ? value.replace(/^\/+/, "")
            : value;
        element.setAttribute(attribute, new URL(normalizedValue, baseUrl).href);
      } catch (error) {
        // Keep the original value when it cannot be parsed as a URL.
      }
    });
  });
  return container.innerHTML;
};

export const buildSilentPrintHtml = (contentHtml = "") => {
  if (typeof document === "undefined") return contentHtml;

  // Inline CSS rules thực tế thay vì dùng <link> tags
  // vì worker BrowserWindow không load được các external CSS tập tin do CORS
  let printStylesHtml = "";
  try {
    const sheets = Array.from(document.styleSheets);
    let inlineRulesText = "";
    for (const sheet of sheets) {
      try {
        const rules = Array.from(sheet.cssRules || sheet.rules || []);
        inlineRulesText += rules.map((r) => r.cssText).join("\n") + "\n";
      } catch (e) {
        // Cross-origin stylesheet - fallback to ownerNode outerHTML
        if (sheet.ownerNode) {
          printStylesHtml += sheet.ownerNode.outerHTML + "\n";
        }
      }
    }
    if (inlineRulesText) {
      printStylesHtml += `<style>${inlineRulesText}</style>\n`;
    }
  } catch (e) {
    // Fallback: sử dụng phương pháp cũ nếu có lỗi
    printStylesHtml = Array.from(
      document.querySelectorAll("link[rel='stylesheet'], style"),
    )
      .map((el) => el.outerHTML)
      .join("\n");
  }

  const absoluteStyleTags = makePrintResourcesAbsolute(printStylesHtml);
  const absoluteContentHtml = makePrintResourcesAbsolute(contentHtml);

  return `
    <!doctype html>
    <html data-vmass-silent-print="receipt" data-vmass-paper-width-mm="${PRINT_THERMAL_PAPER_WIDTH_MM}">
      <head>
        <meta charset="utf-8" />
        <meta name="vmass-paper-width-mm" content="${PRINT_THERMAL_PAPER_WIDTH_MM}" />
        ${absoluteStyleTags}
        <style>${SILENT_PRINT_PAGE_STYLE}</style>
      </head>
      <body>${absoluteContentHtml}</body>
    </html>
  `;
};

export const generateStockSku = () => {
  if (
    typeof window !== "undefined" &&
    window.crypto &&
    typeof window.crypto.randomUUID === "function"
  ) {
    return `NL-${window.crypto.randomUUID().replace(/-/g, "").substring(0, 8).toUpperCase()}`;
  }
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let randomStr = "";
  for (let i = 0; i < 8; i += 1) {
    randomStr += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return `NL-${randomStr}`;
};
